(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["densea-product"] && !Shopify.designMode) return;
  try {
    

function initDensea(){document.querySelectorAll('[data-densea-page]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 if(location.pathname==='/products_preview'&&root.dataset.denseaThemeId){const u=new URL(location.href);u.searchParams.set('preview_theme_id',root.dataset.denseaThemeId);history.replaceState({},'',u);}
 const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const film=root.querySelector('[data-gallery-video]'), galleryButton=root.querySelector('[data-gallery-pause]');
 let galleryActive=false,galleryManual=false;
 const syncGallery=()=>{galleryButton.textContent=film.paused?'▷':'Ⅱ';galleryButton.setAttribute('aria-label',film.paused?'Lire l’animation':'Mettre l’animation en pause');};
 const galleryRun=play=>{if(play)film.play().catch(syncGallery);else film.pause();};
 film.addEventListener('play',syncGallery);film.addEventListener('pause',syncGallery);
 galleryButton.addEventListener('click',()=>{galleryManual=!film.paused;galleryRun(film.paused);});
 const returnLink=root.querySelector('.ds-return-reassurance');
 if(returnLink)returnLink.addEventListener('click',()=>{root.querySelector('#densea-guarantee').open=true;});
 const selectGallery=n=>{
  root.querySelectorAll('.ds-thumb').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.index)===n)));
  root.querySelectorAll('[data-gallery-panel]').forEach(p=>p.hidden=Number(p.dataset.galleryPanel)!==n);
  galleryActive=n===1;galleryManual=false;
  if(galleryActive){film.currentTime=0;galleryRun(!reduced);}else galleryRun(false);
 };
 root.querySelectorAll('.ds-thumb').forEach(btn=>btn.addEventListener('click',()=>selectGallery(Number(btn.dataset.index))));
 const selectPackPhoto=input=>{
  const photo=root.querySelector('[data-pack-photo]');
  const thumb=root.querySelector('[data-pack-photo-thumb]');
  if(!photo||!input.dataset.packPhotoSrc)return;
  photo.alt=input.dataset.packPhotoAlt;
  photo.srcset=input.dataset.packPhotoSrcset;
  photo.src=input.dataset.packPhotoSrc;
  if(thumb){thumb.src=input.dataset.packPhotoThumbSrc;thumb.closest('button').setAttribute('aria-label',input.dataset.packPhotoAlt);}
  selectGallery(5);
 };
 root.querySelectorAll('input[data-densea-variant]').forEach(input=>input.addEventListener('click',()=>selectPackPhoto(input)));
 new IntersectionObserver(entries=>entries.forEach(e=>galleryRun(e.isIntersecting&&galleryActive&&!galleryManual&&!reduced)),{threshold:.1}).observe(root.querySelector('.ds-gallery-stage'));
 root.querySelectorAll('input[data-densea-variant]').forEach(input=>input.addEventListener('change',()=>{root.querySelector('.ds-form input[name="id"]').value=input.value;selectPackPhoto(input);root.querySelectorAll('[data-selected-price]').forEach(e=>e.textContent=input.dataset.price);root.querySelectorAll('[data-selected-title]').forEach(e=>e.textContent=input.dataset.title);const u=new URL(location.href);u.searchParams.set('variant',input.value);history.replaceState({},'',u);}));
 const variantId=new URL(location.href).searchParams.get('variant');if(variantId){const radio=[...root.querySelectorAll('input[data-densea-variant]')].find(e=>e.value===variantId);if(radio){radio.checked=true;radio.dispatchEvent(new Event('change'));}}
 selectGallery(0);
 const video=root.querySelector('[data-loop-video]'), control=root.querySelector('[data-video-control]');let manualPaused=false;
 const sync=()=>{control.textContent=video.paused?'▷':'Ⅱ';control.setAttribute('aria-label',video.paused?'Lire l’animation':'Mettre l’animation en pause');};
 const run=play=>{if(play)video.play().catch(sync);else video.pause();};video.addEventListener('play',sync);video.addEventListener('pause',sync);
 control.addEventListener('click',()=>{manualPaused=!video.paused;run(video.paused);});new IntersectionObserver(es=>es.forEach(e=>run(e.isIntersecting&&!reduced&&!manualPaused)),{threshold:.2}).observe(root.querySelector('.ds-video-shell'));
 const tabs=[...root.querySelectorAll('[data-compare-tab]')];
 const selectTab=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});root.querySelectorAll('[data-compare-panel]').forEach(p=>p.hidden=p.dataset.comparePanel!==tab.dataset.compareTab);};
 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>selectTab(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();selectTab(tabs[n]);tabs[n].focus();});});
 const sticky=root.querySelector('[data-sticky]'),offer=root.querySelector('.ds-form');new IntersectionObserver(es=>es.forEach(e=>sticky.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.bottom<0)),{threshold:0}).observe(offer);
 root.querySelectorAll('a[href="#densea-offre"],a[data-review-anchor]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const target=root.querySelector(a.getAttribute('href'));if(target)target.scrollIntoView({behavior:reduced?'auto':'smooth'});}));
});}initDensea();document.addEventListener('shopify:section:load',initDensea);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formula-tab-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.formula-tab-section').forEach((section) => {
      const wrappers = section.querySelectorAll('.formula-tab-wraper');
      const contents = section.querySelectorAll('.tab-content');

      wrappers.forEach((wrap) => {
        wrap.addEventListener('click', function () {
          wrappers.forEach((w) => w.classList.remove('active'));
          contents.forEach((c) => c.classList.remove('active'));

          this.classList.add('active');
          const tab = this.querySelector('.tab-btn').dataset.tab;
          section.querySelector('.' + tab).classList.add('active');
        });
      });

      new Swiper(section.querySelector('.women-swiper'), {
        slidesPerView: 1.9,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 3.5,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4.5,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 9,
          },
        },
      });

      new Swiper(section.querySelector('.men-swiper'), {
        slidesPerView: 1.9,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 3.5,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 4.5,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 9,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
